import { render, staticRenderFns } from "./salesProductDetails.vue?vue&type=template&id=4a92cec8&"
import script from "./salesProductDetails.vue?vue&type=script&lang=js&"
export * from "./salesProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesProductDetails.vue?vue&type=style&index=0&id=4a92cec8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports